<template>
  <div class="layout-box">
    <div class="header-box">
      <span style="font-size: 20px; font-weight: bold;" v-if="isUmebro">博色广告平台</span>
      <span :class="`sys-title ${isHL ? 'sys-title-hl' : ''}`" v-else>{{title}}平台</span>
      <span class="user-name">{{displayName}}</span>
      <el-divider direction="vertical" />
      <a class="btn-logout" @click="logout">退出</a>
    </div>
    <div class="content-box">
      <div class="menu-box" id="wrap_left">
        <el-menu :default-active="$route.path" class="el-menu-demo" @select="handleSelect" :default-openeds="defaultOpened">
          <template v-for="item in memus.filter(m=>m.meta&&m.meta.show)">
            <el-submenu
              :key="item.name"
              :index="item.name"
              v-if="item.meta && item.meta.show && (!item.meta.perm || item.meta.perm(userInfo))"
            >
              <template slot="title">
                <i :class="`icon-menu ${item.icon}`" />
                {{item.label}}
              </template>
              <template
                  v-for="child in item.children">
                <el-menu-item
                  v-if="child.meta && child.meta.show && (!child.meta.perm || child.meta.perm(userInfo))"
                  :key="child.name"
                  :index="child.name"
                  :class="{
                    'active': child.name === $route.name
                  }"
                >{{child.label}}<span v-if="child.name === 'accessSdk' && hasDocUpdate" class="doc-new-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="28" height="28"><path d="M798.8 287.3h-553C110.7 287.3 0 397.9 0 533.1v204.8h798.8c124.9 0 225.2-100.4 225.2-225.3 0.1-125-100.3-225.3-225.2-225.3zM346.7 630.8l-48-0.2-68.9-150c-3.6-7.8-6-14.1-7.5-18.9h-0.7c-0.5 8-2 20.3-4.8 36.9l-21.4 131.5-44.4-0.1 37.5-231.2 51.1 0.2 66.1 145.8c4.4 9.6 7 15.8 8 18.4h0.8c0-5.6 1.2-16.2 3.8-32l21.4-131.8 44.4 0.1-37.4 231.3z m212.7-190.2l-78.1-0.2-8.9 54.5 72.6 0.2-6.5 40.1-72.6-0.2-9.1 56 83.2 0.4-6.5 40.3-130.1-0.5L440.9 400l125 0.5-6.5 40.1z m241.9 192l-52.1-0.2-13-150.9c-0.6-8.1-0.5-16.6 0.6-25.5h-0.6c-2.6 10.4-5.4 18.9-8.1 25.5L665.3 632.1l-54-0.2-21.1-231.5 51.4 0.2 7.3 156.9c0.2 6.9-0.1 15.5-1.2 26h1c1.7-8.1 4.7-17 8.7-26.7l66.1-155.9 49.7 0.2 11.5 158.1c0.5 6.2 0.4 14.5-0.4 24.5h0.8c1.7-8.6 4.2-17.1 7.4-25.4l57.4-156.9 47.5 0.2-96.1 231z m0 0" fill="#d81e06"/></svg></span></el-menu-item>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <div class="main-box">
        <router-view />
      </div>
    </div>
  
    <el-dialog
      title="提示"
      :visible.sync="accountDialogVisible"
      width="30%"
    >
      <span>请完善账户信息，完善后可进行其他操作。</span>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="accountDialogVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { doLogout, getUserInfo } from '@/apis/login.js';
import { localStorage } from '@/common/storage';
import { TOKEN } from '@/common/storageKeys';
import routes from '@/router/routes';
import { isHL, isUmebro, getPlatformTitle, getICP } from '@/common/utils';
import { getDocList, isRecentlyUpdated } from '@/apis/docConfig';

export default {
  data () {
    let memus = []
    routes.forEach(v => {
        memus.push(v);
    });
    
    return {
      userInfo: {},
      memus,
      active: memus.name,
      icpText: getICP(),
      defaultOpened: [],
      accountDialogVisible: false,
      hasDocUpdate: false, // 对接文档是否有更新（显示 NEW 图标）
    }
  },
  created() {
    this.getUserInfo();
    this.checkDocUpdates();
  },
  computed: {
    displayName () {
      return this.userInfo.display_name || this.userInfo.name || this.userInfo.username || '--'
    },
    isHL () {
      return isHL()
    },
    isUmebro() {
      return isUmebro()
    },
    title () {
      return getPlatformTitle()
    },
  },
  methods: {
    async getUserInfo() {
      const data = await getUserInfo();
      this.userInfo = data.data;
      this.$ls.set('userInfo', this.userInfo)
      // 子账号自动跳转对应权限页面
      if (this.userInfo.main_user) {
        // this.defaultOpened.push('adCenter');
        // if (this.userInfo.qm_frontend_tabs_arr.media) {
        //   this.$router.push('/flow/applist');
        //   return;
        // }
        // if (this.userInfo.qm_frontend_tabs_arr.adslot) {
        //   this.$router.push('/flow/codelist');
        //   return;
        // }
        // if (this.userInfo.qm_frontend_tabs_arr.shield_rule) {
        //   this.$router.push('/advCenter/shield');
        //   return;
        // }
        // if (this.userInfo.only_review_auth) {
        //   this.$router.push('/adCenter/review');
        //   return;
        // }
        // if (this.userInfo.only_preview_auth) {
        //   this.$router.push('/adCenter/preview');
        //   return;
        // }
        // if (this.userInfo.qm_frontend_tabs_arr.report) {
        //   this.$router.push('/data/dataList');
        //   return;
        // }
        // if (this.userInfo.qm_frontend_tabs_arr.document) {
        //   this.$router.push('/access/sdk');
        //   return;
        // }
        // if (this.userInfo.qm_frontend_tabs_arr.logo) {
        //   this.$router.push('/access/adv');
        //   return;
        // }
        // if (this.userInfo.qm_frontend_tabs_arr.account_info) {
        //   this.$router.push('/account/info');
        //   return;
        // }

        // 定义一个变量存储当前需要展开的父菜单name
        let parentMenuName = '';
        if (this.userInfo.qm_frontend_tabs_arr.media) {
          this.$router.push('/flow/applist');
          parentMenuName = 'flow'; // 对应路由的父菜单name是flow
        } else if (this.userInfo.qm_frontend_tabs_arr.adslot) {
          this.$router.push('/flow/codelist');
          parentMenuName = 'flow';
        } else if (this.userInfo.qm_frontend_tabs_arr.shield_rule) {
          this.$router.push('/advCenter/shield');
          parentMenuName = 'adCenter'; // 对应父菜单是adCenter
        } else if (this.userInfo.only_review_auth) {
          this.$router.push('/adCenter/review');
          parentMenuName = 'adCenter';
        } else if (this.userInfo.only_preview_auth) {
          this.$router.push('/adCenter/preview');
          parentMenuName = 'adCenter';
        } else if (this.userInfo.qm_frontend_tabs_arr.report) {
          this.$router.push('/data/dataList');
          parentMenuName = 'data'; // 对应父菜单是data
        } else if (this.userInfo.qm_frontend_tabs_arr.document) {
          this.$router.push('/access/sdk');
          parentMenuName = 'access'; // 对应父菜单是access
        } else if (this.userInfo.qm_frontend_tabs_arr.logo) {
          this.$router.push('/access/adv');
          parentMenuName = 'access';
        } else if (this.userInfo.qm_frontend_tabs_arr.account_info) {
          this.$router.push('/account/info');
          parentMenuName = 'account'; // 对应父菜单是account
        }
        // 根据实际跳转的路由，设置对应的父菜单展开
        if (parentMenuName) {
          this.defaultOpened = [parentMenuName]; // 动态设置默认展开的菜单
        }
        return;
      }

      // 账户主体信息缺失
      if (this.userInfo && this.userInfo.account_status !== 1 && !this.isUmebro) {
        this.accountDialogVisible = true;
        this.$router.push('/account/info');
        return;
      }
    },
    async logout() {
      await doLogout();
      localStorage.removeItem(TOKEN);
      window.localStorage.removeItem('qumeng__userInfo');
      // this.$router.push('/login');
      window.location.href = '/login';
    },
    handleSelect(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    /** 检查对接文档是否有更新（7天内有发布则显示 NEW 图标） */
    async checkDocUpdates() {
      const docIds = [1, 4, 5, 6, 8, 9];
      const { server_time, docs } = await getDocList(docIds);
      this.hasDocUpdate = docs.some(d => isRecentlyUpdated(d.publish_time, server_time));
    },
    handleJumpBeian() {
      window.open('https://beian.miit.gov.cn', '_blank');
    }
  }
}
</script>

<style lang="scss">
:root {
    --bs-theme-color: #ccc;
}

  .layout-box {
    .content-box {
      overflow-y: auto;
      .menu-box {
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
        .el-menu {
          border-right: none;
          .el-submenu {
            .el-submenu__title {
              display: flex;
              align-items: center;
              padding: 24px 32px 14px;
              padding-left: 32px !important;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #9B9FA8;
              line-height: 18px;
              .icon-menu {
                display: inline-block;
                width: 18px;
                height: 18px;
                margin-right: 20px;
                background-size: 100% 100%;
                background-position: center;
                background-repeat: no-repeat;
                &.icon-flow {
                  background-image: url("./images/icon_flow.png");
                }
                &.icon-data {
                  background-image: url("./images/icon_data.png");
                }
                &.icon-settlement {
                  background-image: url("./images/icon_settlement.png");
                }
                &.icon-access {
                  background-image: url("./images/icon_access.png");
                }
                &.icon-account {
                  background-image: url("./images/icon_account.png");
                }
              }
            }
            .el-submenu__icon-arrow {
              &::before {
                display: none;
              }
            }
            .el-menu-item {
              padding: 14px 0 14px 70px;
              padding-left: 70px !important;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #303133;
              line-height: 18px;
              &.active {
                color: #4F90FF;
              }
              .doc-new-icon {
                display: inline-flex;
                align-items: center;
                margin-left: 6px;
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
  .layout-box {
    width: 100%;
    height: 100%;
    background: #F3F7F9;
    .header-box {
      padding: 0 60px;
      height: 60px;
      background: #FFFFFF;
      box-shadow: 0px 1px 5px 0px rgba(220, 222, 224, 0.4);
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 14px;
      .sys-title {
        flex-shrink: 0;
        padding-left: 90px;
        background-image: url('~@/assets/images/logo.png');
        background-size: 80px 23px;
        background-position: 0 center;
        background-repeat: no-repeat;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #303133;
        line-height: 28px;
        &.sys-title-hl {
          background-image: url("~@/assets/images/logo_hl.png");
        }
      }
      .user-name {
        flex-grow: 1;
        margin-right: 2px;
        text-align: right;
      }
      .btn-logout {
        flex-shrink: 0;
        margin-left: 2px;
      }
    }
    .content-box {
      height: calc(100% - 50px);
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      >div {
        height: 100%;
        background: #FFFFFF;
        box-shadow: 0px 1px 5px 0px rgba(220, 222, 224, 0.4);
        border-radius: 4px;
      }
      .menu-box {
        width: 180px;
      }
      .main-box {
        margin-left: 18px;
        width: calc(100% - 180px);
      }
    }
    .icp-text {
      flex-shrink: 0;
      width: 100%;
      height: 60px;
      line-height: 30px;
      text-align: center;
      color: #989898;
      cursor: pointer;
    }
  }
</style>